import Decimal from "decimal.js";

export const parseDecimalInput = (value: string | number | null | undefined): number => {
  if (value === null || value === undefined || value === "") return 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const dollarsToCents = (value: string | number | null | undefined): number =>
  new Decimal(parseDecimalInput(value))
    .times(100)
    .toDecimalPlaces(0, Decimal.ROUND_HALF_UP)
    .toNumber();

export const centsToDollarsInput = (value: string | number | null | undefined): string => {
  const cents = parseDecimalInput(value);
  if (cents === 0) return "";
  return new Decimal(cents).div(100).toString();
};
